// src/App.jsx
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";

import Login from "./components/logIn/login";
import Home from "./components/home/Home";
import MainLayout from "./layout/MainLayout";
import ProfileScreen from "./components/profile.jsx";
import PersonalInfoPage from "./components/personalInfo.jsx";
import Payment from "./components/logIn/payment.jsx";
import ForgotPassword from "./components/logIn/forgot-password.jsx";
import SignUp from "./components/signup/signupfiled.jsx";
import { TermsModal } from "./components/signup/termmodal.jsx";
import ChatScreen from "./components/chatScreen/chatScreen.jsx";
import GroupScreen from "./components/groupScreen/groupScreen.jsx";
import CreateGroup from "./components/creategroup/creategroup.jsx";
import Otp from "./components/logIn/otp.jsx";
import Dashboard from "./components/admin/dashboard/dashboard.jsx";
import AdminLogin from "./components/admin/logIn/login.jsx";
import Revenue from "./components/admin/revenue/rebenue.jsx";
import ChangePassword from "./components/admin/change-pass.jsx";
import AdminContact from "./components/admin/admin-contact.jsx";
import AdminLayout from "./layout/AdminLayout.jsx";
import WaitList from "./components/logIn/wait-list.jsx";
import FriendInfo from "./components/friendProfile.jsx";
import ChatDemo from "./components/chatDemo.jsx";
import Notification from "./components/notification.jsx";
import AdminForgotPassword from "./components/admin/logIn/forgot-password.jsx";
import SignupOtp from "./components/signup/otp.jsx";
import InvitationCode from "./components/logIn/invitation-code.jsx";
import AppSetupPage from "./components/logIn/appSetupPage.jsx";
import AdminBroadcast from "./components/admin/broadcast.jsx";
import AdminChat from "./components/admin/chat.jsx";

// OneSignal service
import oneSignalService from "./services/oneSignalService";
import { AboutUs } from "./components/signup/aboutUs.jsx";
import GuestOnlyRoute from "./components/common/GuestOnlyRoute.jsx";
import AuthRequiredRoute from "./components/common/AuthRequiredRoute.jsx";
import { migrateSessionStorageToLocalStorage } from "./utils/appStorage";
import useVisualViewportHeight from "./hooks/useVisualViewportHeight";

const guest = (element) => <GuestOnlyRoute>{element}</GuestOnlyRoute>;
const auth = (element) => <AuthRequiredRoute>{element}</AuthRequiredRoute>;

export default function App () {
  useVisualViewportHeight();

  useEffect(() => {
    migrateSessionStorageToLocalStorage();
  }, []);

  // Initialize OneSignal once at app startup
  useEffect(() => {
    const initializeOneSignal = async () => {
      try {
        // Check notification support first
        const supportInfo = oneSignalService.checkNotificationSupport();

        if (!supportInfo.supported) {
          }

      

        // Initialize OneSignal service
        await oneSignalService.initialize();

        // Wait a bit for initialization to complete (longer for Safari)
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        await new Promise(resolve => setTimeout(resolve, isSafari ? 2000 : 1000));

        // Request notification permission
        const permissionGranted = await oneSignalService.requestPermission();
        
       

        // Get player ID
        const playerId = await oneSignalService.getPlayerId();
        const isSubscribed = await oneSignalService.isSubscribed();

       
        // If we got a player ID and have auth token, register with backend
        if (playerId) {
          const authToken = localStorage.getItem('jwt_token');
          if (authToken) {
            await oneSignalService.registerWithBackend(playerId, authToken);
          }
        } else if (!playerId && isSubscribed) {
          // Retry getting player ID after a delay
          await new Promise(resolve => setTimeout(resolve, 2000));
          const retryPlayerId = await oneSignalService.getPlayerId();
          if (retryPlayerId) {
            const authToken = localStorage.getItem('jwt_token');
            if (authToken) {
              await oneSignalService.registerWithBackend(retryPlayerId, authToken);
            }
          }
        }
      } catch (error) {
        }
    };

    initializeOneSignal();
  }, []);
    
 

  return (
    <BrowserRouter>
      <Routes>
        {/* Home landing page */}
        <Route index element={guest(<Home />)} />

        {/* Admin login route */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path='/admin/forgot-password' element={<AdminForgotPassword />}  />

        {/* Admin routes (nested under AdminLayout) */}
        <Route element={<AdminLayout />}>
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin-contact" element={<AdminContact />} />
          <Route path="/admin-broadcast" element={<AdminBroadcast />} />
          <Route path="/admin-chat" element={<AdminChat />} />
          <Route path="/revenue" element={<Revenue />} />
          <Route path="/password-change" element={<ChangePassword />} />
        </Route>

        {/* Public routes — redirect to /contact when already logged in */}
        <Route path="/home" element={guest(<Home />)} />
        <Route path="/login" element={guest(<Login />)} />
        <Route path="/wait-list" element={guest(<WaitList />)} />
        <Route path="/app-setup" element={guest(<AppSetupPage />)} />
        <Route path="/invitation-code" element={guest(<InvitationCode />)} />
        <Route path="/forgot-password" element={guest(<ForgotPassword />)} />
        <Route path="/change-password" element={guest(<ChangePassword />)} />
        <Route path="/otp" element={guest(<Otp />)} />
        <Route path="/sign-up" element={guest(<SignUp />)} />
        <Route path="/sign-up/otp" element={guest(<SignupOtp />)} />
        <Route path="/term-condition" element={guest(<TermsModal />)} />
        <Route path="/about-us" element={guest(<AboutUs />)} />
        <Route path="/payment" element={auth(<Payment />)} />
        <Route path="/razorpay-payment" element={<Navigate to="/payment" replace />} />
        <Route path="/chat-demo" element={<ChatDemo />} />

        {/* Main user routes (nested under MainLayout) */}
        <Route element={<MainLayout />}>
          <Route path="/contact" element={<ProfileScreen />} />
          <Route path="/personal-info" element={<PersonalInfoPage />} />
          <Route path="/notifications" element={<Notification />} />
          <Route path="/chat" element={<ChatScreen />} />
          <Route path="/chat/:user_id" element={<ChatScreen />} />
          <Route path="/groupchat" element={<GroupScreen />} />
          <Route path="/creategroup" element={<CreateGroup />} />
          <Route path="/friend-profile/:user_id" element={<FriendInfo />} />
        </Route>

        {/* Optional: redirect all unknown paths to login */}
        {/* <Route path="*" element={<Navigate to="/login" replace />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

